import React from 'react'
import { component_tool } from '../../../tool'
let { WizDataTable, WizIcon, WizButton, WizDivider } = component_tool

export default (self, employees, other) => {
    return [
        {
            title: 'id',
            name: 'id',
            formItem: {
                type: 'hidden'
            }
        },
        {
            title: 'personId',
            name: 'personId',
            formItem: {
                type: 'hidden'
            }
        },
        {
            title: 'delFlag',
            name: 'delFlag',
            formItem: {
                type: 'hidden'
            }
        },
        {
            title: '账号',
            name: 'searchUserName',
            searchItem: {}
        },
        {
            title: '账号',
            name: 'userName',
            tableItem: {},
            formItem: {
                rules: [{
                    required: true,
                    message: '请输入账号'
                }],
            }
        },
        {
            title: '姓名',
            name: 'fullName',
            tableItem: {},
            formItem: {
                rules: [{
                    required: true,
                    message: '请输入姓名'
                }],
            }
        },
        {
            title: '手机号',
            name: 'searchMobile',
            searchItem: {}
        },
        {
            title: '手机号',
            name: 'mobile',
            tableItem: {},
            formItem: {}
        },
        {
            title: '邮箱',
            name: 'searchEmail',
            searchItem: {}
        },
        {
            title: '邮箱',
            name: 'email',
            tableItem: {},
            formItem: {}
        },
        {
            title: '状态',
            name: 'disabled',
            dict: [
                { code: 0, codeName: '激活' },
                { code: 1, codeName: '禁用' },
            ],
            tableItem: {},
            searchItem: {
                type: 'select',
                // initialValue: 1
            },
            formItem: {
                type: 'select',
                rules: [{
                    required: true,
                    message: '请选择状态'
                }]
            }
        },
        {
            title: '创建日期',
            name: 'createTime',
            tableItem: {}
        },
        {
            title: '操作',
            tableItem: {
                width: 200,
                render: (text, record) => (
                    <WizDataTable.Oper>
                        <WizButton tooltip="编辑" onClick={e => self._onUpdate(record)}>
                            编辑
                        </WizButton>
                        <WizButton tooltip="禁用" onClick={e => self._onDisabled(record)}>
                            禁用
                        </WizButton>
                        <WizButton tooltip="角色管理" onClick={e => self._onManagement(record)}>
                            角色管理
                        </WizButton>
                    </WizDataTable.Oper>
                )
            }
        }
    ]
}